import React from "react";
import Card from "../../components/Card/Card";
import HeroSection from "../../components/HeroSection/HeroSection";

function Home() {
  return (
    <div className="Home">
      <HeroSection />
      <Card />
    </div>
  );
}

export default Home;
